"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var search_1 = require("@usereactify/search");
var product_card_1 = require("./product-card");
var FilterContainer_1 = require("../../reactify/filters/FilterContainer");
var searchResultsNumberedPagination_1 = require("./searchResultsNumberedPagination");
var searchResultsStats_1 = require("./searchResultsStats");
var searchResultsSortBy_1 = require("./searchResultsSortBy");
var SearchPage = /** @class */ (function (_super) {
    __extends(SearchPage, _super);
    function SearchPage(props) {
        var _this = _super.call(this, props) || this;
        _this.setFiltersOpen = function (open) {
            if (_this.state.filtersOpen !== open) {
                _this.setState({
                    filtersOpen: open,
                });
            }
        };
        _this.setPerPage = function (pageSize) {
            _this.setState({
                perPage: pageSize,
            });
        };
        _this.handleResize = function () {
            _this.setState({
                isMobile: window.innerWidth < 768,
            });
        };
        _this.renderSearchBanner = function (bgImage, term) { return (React.createElement(Snippets.Container, { className: "flex justify-center ", tag: "section", width: "full", bgImage: bgImage },
            React.createElement("div", { className: "flex flex-col items-center text-center py-4-3 md:py-8-3" },
                React.createElement(search_1.Stats, { render: function (renderProps) { return React.createElement(searchResultsStats_1.SearchPageStats, __assign({}, renderProps, { searchTerm: term })); } })))); };
        _this.renderCollectionBanner = function (bgImage, title, metafields) {
            var _a;
            return (React.createElement(Snippets.Container, { tag: "section", width: "full", bgImage: bgImage },
                React.createElement(Snippets.Container, { width: "xl", className: "px-1-6 md:px-11" },
                    React.createElement("div", { className: "w-full font-bold leading-none pl-2-8 md:pl-1/8 py-5-6 md:py-9-6 text-arctic text-xmd md:text-48" }, ((_a = metafields.custom) === null || _a === void 0 ? void 0 : _a.hide_header_title) ? "" : title))));
        };
        _this.state = {
            sortOption: 0,
            perPage: _this.props.perPage,
            filtersOpen: false,
            isMobile: window.innerWidth < 768,
            page: 0,
            searchConfig: _this.props.searchConfig,
        };
        return _this;
    }
    SearchPage.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.handleResize);
    };
    SearchPage.prototype.render = function () {
        var _this = this;
        var _a = this.props, searchTerm = _a.searchTerm, collection = _a.collection, searchUrl = _a.searchUrl, searchKey = _a.searchKey, bgImage = _a.bgImage, seoHeader = _a.seoHeader, seoContent = _a.seoContent, infoHeader = _a.infoHeader, infoContent = _a.infoContent;
        var pageLimits = [8, 16, 32];
        var seoSection = seoHeader && seoContent ? (React.createElement("div", { className: "hidden w-full border-t px-1-2 md:block pt-3-3 mb-0-8 border-secondary-blue-grey min-h-10" },
            React.createElement("h1", { className: "font-semibold text-xmd text-midnight mb-2-2" }, seoHeader),
            React.createElement("p", { className: "md:w-4/5 w-full text-base leading-normal text-grey-dark" }, seoContent))) : null;
        return searchUrl && searchKey ? (React.createElement(React.Fragment, null,
            React.createElement(search_1.ReactifySearchProvider, { mode: collection && !searchTerm ? "collection" : "search", shopifyPermanentDomain: window.Shopify.shop, collectionHandle: collection ? collection.handle : "", theme: {
                    typography: {
                        fontFamily: "\"Titillium\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", \"sans-serif\"",
                    },
                    colors: null,
                }, className: "bg-very-light-pink" },
                searchTerm ? this.renderSearchBanner(bgImage, searchTerm) : this.renderCollectionBanner(bgImage, collection.title, collection.metafields),
                React.createElement("div", { className: "bg-arctic md:bg-very-light-pink" },
                    React.createElement("div", { className: "max-w-xl mx-auto mlg:px-11 md:px-3" },
                        React.createElement("div", { className: "flex flex-row md:pt-1-6 md:pb-2-4 ie-results-filters" },
                            React.createElement("div", { className: "hidden md:flex items-center md:mr-2 w-1/2" },
                                React.createElement(search_1.Stats, { render: function (renderProps) { return React.createElement(searchResultsStats_1.PaginationStats, __assign({}, renderProps)); } })),
                            React.createElement("div", { className: "w-1/2 md:hidden border-r md:border-0 border-grey-light pl-3-2 pr-2-4" },
                                React.createElement("button", { onClick: function () { return _this.setFiltersOpen(true); }, className: "filter-btn flex items-center justify-between flex-no-wrap w-full h-full text-midnight font-semibold text-sm tracking-tight focus:outline-none transition-fast" },
                                    React.createElement("p", { className: "filter-btn-text block md:inline-block align-middle" }, "Filter "),
                                    React.createElement(Snippets.Svg, { name: "filter", width: 15, height: 15, className: "block align-middle md:ml-1-7 h-2.5 min-w-2.5" }))),
                            React.createElement("div", { className: "relative items-center mr-3 hidden md:flex md:ml-0-6" },
                                "View\u00A0",
                                pageLimits.map(function (limit) { return (React.createElement("button", { key: limit, className: (limit == _this.state.perPage
                                        ? " text-arctic appearance-none border-none outline-none focus:outline-none bg-accent-primary rounded-half"
                                        : "") + " flex items-center justify-center text-center  w-3-2 h-3-2  font-bold mx-0-4 inline-block pointer-cursor text-md font-normal cursor-pointer", onClick: function () {
                                        _this.setPerPage(limit);
                                    } }, limit)); })),
                            React.createElement("div", { className: "w-1/2 md:w-full flex items-center border-l md:border-0 border-grey-light py-1 md:py-0 pl-1-8 md:pl-0" },
                                React.createElement(search_1.SortBy, { render: searchResultsSortBy_1.SearchResultsSortBy }))))),
                React.createElement(search_1.Sensors, null),
                React.createElement("section", { className: "bg-very-light-pink w-full " + (this.state.isMobile ? (this.state.filtersOpen ? "h-32 overflow-hidden md:h-auto md:overflow-auto" : "") : "") },
                    React.createElement("div", { className: "max-w-xl mx-auto md:px-3 lg:px-11 px-1-6" },
                        React.createElement("div", { className: "flex items-start w-full" },
                            React.createElement(FilterContainer_1.FilterContainer, { filtersOpen: this.state.filtersOpen, isMobile: this.state.isMobile, setFiltersOpen: this.setFiltersOpen }),
                            React.createElement("div", { className: "transition-fast pl-0 " + (this.state.isMobile ? (this.state.filtersOpen ? "md:w-3/4 md:pl-1-2" : "w-full") : "md:w-3/4 md:pl-1-2") },
                                infoHeader || infoContent ? (React.createElement("div", { className: "hidden w-full pb-2 mb-2 border-b px-1-2 md:block border-secondary-blue-grey" },
                                    React.createElement("h1", { className: "font-semibold text-xmd text-midnight mb-2-2" }, infoHeader),
                                    React.createElement("p", { className: (this.state.filters ? "w-4/5" : "w-full") + " text-base leading-normal text-grey-dark" }, infoContent))) : null,
                                React.createElement("div", { className: "-mr-0-8 pt-1-2 md:pt-0 min-h-10" },
                                    React.createElement(search_1.Results, { includeFields: [
                                            "*",
                                        ], listStyle: {}, pageSize: this.state.perPage, listClassName: "flex flex-wrap min-h-10", renderResultCardProduct: function (renderProps) { return (React.createElement(product_card_1.ProductCard, __assign({}, renderProps, { className: "w-1/2 md:w-1/4", collectionThumb: true }))); }, renderPaginationNumbered: function (renderProps) { return React.createElement(searchResultsNumberedPagination_1.SearchResultPaginationNumbered, __assign({}, renderProps)); } }),
                                    seoSection)))))))) : null;
    };
    return SearchPage;
}(React.Component));
exports.SearchPage = SearchPage;
